export default class PageTitle extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-page-title', PageTitle);
